/* eslint-disable prettier/prettier */
/* eslint-disable max-len */

/*
 * Copyright (c) 2023, WSO2 LLC. (http://www.wso2.com). All Rights Reserved.
 *
 * This software is the property of WSO2 LLC. and its suppliers, if any.
 * Dissemination of any information or reproduction of any material contained
 * herein is strictly forbidden, unless permitted by WSO2 in accordance with
 * the WSO2 Commercial License available at http://wso2.com/licenses.
 * For specific language governing the permissions and limitations under
 * this license, please see the license as well as any agreement you’ve
 * entered into with WSO2 governing the purchase of this software and any
 * associated services.
 */

import { createSvgIcon } from '@material-ui/core';
import * as React from 'react';

export default createSvgIcon(
  <React.Fragment>
    <path
      fill="currentColor"
      d="M6 12a.75.75 0 0 1 .75-.75h9a.75.75 0 0 1 0 1.5h-9A.75.75 0 0 1 6 12ZM6.75 16.25a.75.75 0 0 0 0 1.5h6a.75.75 0 0 0 0-1.5h-6Z"
    />
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M19 0c1.6569 0 3 1.3432 3 3v18c0 1.6569-1.3431 3-3 3H5c-1.6568 0-3-1.3431-3-3V3c0-1.6568 1.3432-3 3-3h14Zm-6 1.5h6c.8284 0 1.5.6716 1.5 1.5v18c0 .8284-.6716 1.5-1.5 1.5H5c-.8284 0-1.5-.6716-1.5-1.5V3c0-.8284.6716-1.5 1.5-1.5h1v5.917c0 .244.2758.386.4744.2442L9.5 5.5l3.0256 2.1612C12.7242 7.803 13 7.661 13 7.417V1.5Zm-1.5 0h-4v3.5852l2-1.4286 2 1.4286V1.5Z"
      clipRule="evenodd"
    />
  </React.Fragment>,
  'MenuPolicies'
);
